import React,{useCallback,useEffect,useRef} from 'react'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'
import { addItemToCart } from '../../../app/action'
import {useSelector,useDispatch} from 'react-redux'

import {
  getCID,
  getDataFromURL
} from '../../../utilities/function/urlparams'

import {
  getAttributes
} from '../../../utilities/function/configuration'

import {
  getPriceByBillingCycleName
} from '../../../utilities/function/billingCycle'

import Loading from '../../shared/loading'

let SSL = props => {
  const {location , history} = props
  const {configurations}  = useSelector(state=>({
    configurations: state.app.configurations
  }))
  const cid = getCID(getDataFromURL(location.search))
  const productConfig = configurations[cid]
  const initFlag = useRef(false)
  const dispatch = useDispatch();
  const initSSL = useCallback(()=>{
    if(!initFlag.current && configurations){
      if(productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)){
        const {price} = getAttributes(productConfig.selectedProduct)
        const selectedBillingCycle = getPriceByBillingCycleName(price,'One Time')
        if(selectedBillingCycle){
          const {billing_cycle_id} = selectedBillingCycle
          productConfig.billing_cycle_id = billing_cycle_id
          addItemToCart(productConfig,dispatch,history,configurations,location)
          initFlag.current = true
        }
      }
    }
  },[initFlag,productConfig,dispatch,history,configurations,location])

  useEffect(()=>{
    initSSL()
  },[initSSL])

  return (<Loading className='of-page__loading' wrapper={true} />)
}

SSL.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}

SSL = withRouter(SSL)

export default SSL